import axios from "axios";
import { Base_URL } from "../url";

export const fetchTehsils = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TehsilMaster/GetAllTehsils`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching tehsils!";
  }
};

export const downloadTehsilsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/TehsilMaster/DownloadTehsilsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading tehsils data!";
  }
};